import React from "react";

export default function Navbar() {
  return (
    <header className="navbar">
      <img src="logo.png" alt="ParkGüven Logo" className="logo" />
      <h1>ParkGüven – Akıllı Otopark Çözümü</h1>
      <p className="tagline">Yerin hazır, sen hazır mısın?</p>
    </header>
  );
}
